<template>
  <div class="">
    <div class="row mb-4">
      <div class="col-4">
        <div class="input-group">
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary text-dark" @click="clear">
              <i class="bi bi-arrow-clockwise text-dark"></i>
            </button>
          </div>
          <select
            name=""
            id=""
            class="form-control"
            @change="changeInputType"
            v-model="column"
          >
            <option value="recent">Recently updated</option>
            <option value="lastname">Last Name</option>
            <option value="firstname">First Name</option>
            <option value="created_at">Date Applied</option>
            <option value="abbrev">Institution</option>
          </select>
          <input
            id="search-input"
            type="search"
            class="form-control"
            placeholder="Search"
            v-model="searchValue"
            :disabled="column == 'recent'"
          />
        </div>
      </div>

      <div class="col-auto px-2">
        <button
          @click="
            getPendings({
              tableLoader: { enabled: false },
              reloadLoader: { enabled: true },
            })
          "
          class="btn btn-outline-secondary text-dark"
        >
          <i class="bi bi-arrow-repeat mr-1"></i> Reload
          <div
            v-if="reloadLoader"
            class="spinner-border spinner-border-sm mx-1"
            role="status"
          >
            <span class="invisible">Loading...</span>
          </div>
        </button>
      </div>

      <div class="col-auto px-2">
        <ActionsDropdown
          :selectedApps="selectedApps"
          @updateTable="
            getPendings({
              tableLoader: { enabled: false },
              reloadLoader: { enabled: false },
            })
          "
          :statusId="7"
        ></ActionsDropdown>
      </div>
    </div>
    <div class="table-responsive">
      <table
        id="apps-pending-table"
        class="table table-sm table-bordered table-hover "
      >
        <thead>
          <th>
            <input
              type="checkbox"
              v-model="checked"
              class="large-checkbox"
              @change="checked ? selectAll() : unselectAll()"
            />
          </th>
          <th>APP NO</th>
          <th>NAME</th>
          <th>TYPE</th>
          <th>HEI</th>
          <th>PROGRAM</th>
          <th>PURPOSE</th>
          <th>DATE APPLIED</th>
          <th>CTC</th>
          <th>UPDATED BY</th>
          <th>LAST UPDATE</th>
          <th>STATUS</th>
        </thead>

        <tbody class="text-uppercase">
          <tr v-show="tableLoader" class="text-center">
            <td colspan="13">
              <div class="spinner-border spinner-border-sm mr-2"></div>
              Loading...
            </td>
          </tr>
          <tr v-if="!filteredApps.length && !tableLoader" class="text-center">
            <td colspan="13">No results found.</td>
          </tr>
          <tr
            v-for="app in filteredApps"
            :key="app.id"
            @click.stop="openAppDetailsModal(app)"
            :class="{
              'table-primary font-weight-bold': selectedApps.some(
                (obj) => obj.id == app.id
              ),
            }"
          >
            <td>
              <input
                type="checkbox"
                class="large-checkbox"
                v-model="selectedApps"
                :value="app"
                @click.stop
              />
            </td>
            <td>
              <OverdueIndicator :created_at="app.created_at">
              </OverdueIndicator>
              {{ app.id }}
            </td>
            <td>{{ app.firstname }} {{ app.middlename }} {{ app.lastname }}</td>
            <td>{{ app.student_type }}</td>
            <td>{{ app.abbrev }}</td>
            <td>{{ app.program_name }}</td>
            <td>{{ app.purpose }}</td>
            <td>{{ app.created_at | dateTime }}</td>
            <td class="text-right">{{ app.ctc_qty }}</td>
            <td>{{ app.updated_by }}</td>
            <td>
              <span class="">{{ app.updated_at | duration }}</span>
            </td>

            <td>
              <span class="badge badge-danger">{{ app.status }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <AppDetailsModal ref="AppDetailsModal" :editable="false"></AppDetailsModal>
  </div>
</template>

<script>
import AppDetailsModal from './AppDetailsModal.vue';
import ActionsDropdown from './ActionsDropdown.vue';
import OverdueIndicator from './OverdueIndicator.vue';

export default {
  name: 'Pending',
  components: {
    AppDetailsModal,
    ActionsDropdown,
    OverdueIndicator,
  },
  data() {
    return {
      searchValue: '',
      column: 'recent',
      file: '',
      apps: [],
      selectedApps: [],
      checked: false,
      currentID: '',
      tableLoader: false,
      reloadLoader: false,
    };
  },
  methods: {
    getPendings(config) {
      this.tableLoader = config.tableLoader.enabled;
      this.reloadLoader = config.reloadLoader.enabled;

      axios
        .get('/api/cav-applications/filter/7')
        .then((res) => {
          let sorted = res.data.sort((a, b) => {
            return new Date(b.updated_at) - new Date(a.updated_at);
          });
          this.apps = sorted;
          this.tableLoader = false;
          this.reloadLoader = false;
          this.selectedApps = [];
        })
        .catch((err) => {
          this.tableLoader = false;
          this.reloadLoader = false;
        });
    },
    changeInputType() {
      this.searchValue = '';
      let input = document.getElementById('search-input');
      this.column == 'created_at'
        ? (input.type = 'date')
        : (input.type = 'text');
    },
    clear() {
      this.column = '';
      this.searchValue = '';
    },

    deleteApp(appId, lastname) {
      if (
        confirm(
          `Are you sure you want to permanently delete this application? \nApp No: ${appId} \nLast Name: ${lastname.toUpperCase()}`
        )
      ) {
        axios
          .delete('api/cav-applications/' + appId)
          .then((res) => {
            this.getPending();
            toastr.success(res.data.msg, 'Information');
          })
          .catch((err) => {
            toastr.error('Something went wrong.', 'Error');
          });
      }
    },

    openAppDetailsModal(data) {
      this.$refs.AppDetailsModal.openModal(data);
    },

    selectAll() {
      this.selectedApps = [];
      this.filteredApps.forEach((app) => {
        this.selectedApps.push(app);
      });
    },

    unselectAll() {
      this.selectedApps = [];
    },
  },

  computed: {
    filteredApps() {
      var temp = this.apps;
      let excluded = [
        'Rebita',
        'Caingles',
        'Makidato',
        'Gozon',
        'Canlas',
        'Cabang',
        'Japson',
        'Pupos',
        'Juezan',
      ];

      /* filter by recently updated apps excluding the names
       * ['REBITA', 'CAINGLES', 'MAKIDATO', 'GOZON']
       * added on 6/29/2022
       */
      if (this.column === 'recent') {
        temp = temp.filter((app) => {
          return !excluded.includes(app.updated_by);
        });
      }

      if (this.searchValue != '') {
        temp = temp.filter((cav) => {
          return cav[this.column]
            .toUpperCase()
            .includes(this.searchValue.toUpperCase());
        });
      }

      return temp;
    },
  },
  mounted() {
    this.getPendings({
      tableLoader: { enabled: true },
      reloadLoader: { enabled: false },
    });

    this.$emit('getStats');
  },
};
</script>

<style scoped>
#apps-pending-table tr {
  cursor: pointer !important;
}
</style>
